export function getMenuListOptionId(listboxId: string, itemKey: string) {
  return `${listboxId}-option-${encodeURIComponent(itemKey)}`;
}

export function isMenuListOptionKey(itemKey: string) {
  return /^\d+(?:-\d+)?$/.test(itemKey);
}
